import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { WebsiteGroupRecord } from '../../shared/models/website-group.models';
import { WebsiteGroupsService } from '../services/website-groups.service';
import { PlansService } from '../services/plans.service';
import { forkJoin, map, of, switchMap } from 'rxjs';
import { UsageService } from '../services/usage.service';

export const groupUsageResolver: ResolveFn<WebsiteGroupRecord> = (route) => {
  const groupsService = inject(WebsiteGroupsService);
  const plansService = inject(PlansService);
  const usageService = inject(UsageService);

  const router = inject(Router);

  const freshGroupData$ = groupsService.getGroup(+route.paramMap.get('id')!).pipe(
    switchMap((group) =>
      forkJoin({
        group: of(group),
        plan: plansService.getOneById(group.plan),
        usage: usageService.getDiskUsageByGroup(group.id),
      }),
    ),
    map(({ group, plan, usage }) => ({
      id: group.id,
      plan,
      website: group.websites.find((w) => w.id === group.mainWebsite),
      owner: group.owner,
      websiteCount: group.websites.length,
      usage,
    })),
  );

  const state = router.currentNavigation()?.extras.state;

  return state && state['group'] ? state['group'] : freshGroupData$;
};
